import React, { useRef, useContext } from 'react';
import { APP_ROOT } from 'utils/constants/urls';
import { orderMembershipKit } from 'utils/cartHelpers';
import { UserContext } from '../Layout';

import * as S from './styles';

export type MemberRedemptionModalProps = {
  open: boolean;
  openHandler: any;
  membershipVariantId: number;
};

const handleOrderClick = (
  orderButtonRef: React.RefObject<HTMLDivElement>,
  membershipVariantId: number,
  userId: any,
) => {
  orderMembershipKit(
    orderButtonRef,
    membershipVariantId,
    userId,
    (res: any) => {
      const { id: orderId } = res;
      window.location.href = `${APP_ROOT}/confirmation?orderId=${orderId}&?membershipCreditRedemption=true`;
    },
  );
};

export const MemberRedemptionModal = ({
  open,
  openHandler,
  membershipVariantId,
}: MemberRedemptionModalProps) => {
  const orderButtonRef = useRef(null);
  const userData = useContext(UserContext);
  return open ? (
    <S.Modal open={open} openHandler={openHandler}>
      <S.Title>Would you like to order this test?</S.Title>
      <S.Copy>
        This order counts as one free test included in your membership. Your
        order will be processed immediately and shipped to your address on file.
      </S.Copy>
      <S.ButtonContainer>
        <S.Button appearance="secondary" onClick={() => openHandler(false)}>
          No, thanks
        </S.Button>
        <S.Button
          ref={orderButtonRef}
          appearance="primary"
          onClick={() =>
            handleOrderClick(
              orderButtonRef,
              membershipVariantId,
              userData.userId,
            )
          }
        >
          Order
        </S.Button>
      </S.ButtonContainer>
    </S.Modal>
  ) : null;
};

export default MemberRedemptionModal;
